import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "全大写表示：功能配置；全小写表示：广告配置（即，注意不要轻易更改全大写的配置）", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("建议：通过")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("[项目]_[页面|渠道]_[功能]")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("的方式定义，便于只看广告位置，就知道是做什么的")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("/api/ad/list")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("为满足特殊需求：链接中包含")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("script:")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("，则表示是特殊操作，例如：script:pay，则表示，点击图片，调起支付框，代码需要实现")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "配置描述（README）",
    width: 800
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_collapse, {
        modelValue: _ctx.activeNames,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse_item, {
            title: "广告位置（接口调用code）",
            name: "1"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", null, [
                _hoisted_2,
                _createVNode(_component_el_button, { type: "text" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _hoisted_4
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_collapse_item, {
            title: "页面调用配置接口文档",
            name: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, {
                type: "primary",
                underline: false,
                target: "_blank",
                href: "http://apix.kisops.com/project/1065/interface/api/53341"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_collapse_item, {
            title: "广告特殊配置",
            name: "3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createVNode(_component_el_button, { type: "text" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _hoisted_8
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}